import type { TFunction } from 'i18next';
import type { FaqItem } from '../seo/jsonLd';

export function buildHelpFaqItems(t: TFunction): FaqItem[] {
  const keys = [
    'artwork',
    'promo',
    'team',
    'streaming',
    'motivation',
    'pricing',
    'drive',
    'pwa',
    'notion',
    'mcp',
  ] as const;

  return keys.map((key) => ({
    question: t(`help.faq.${key}.question`),
    answer: t(`help.faq.${key}.answer`),
  }));
}
